import { eventBus, EnumEventBus } from "../managers/EventBus";
import BaseSegmentChord from "../../../../../src/entities/BaseSegmentChord";
import { Coord } from "../../../../../src/types/Interface";
import SegmentModeSwitcherCon from "./SegmentModeSwitcherCon";


export default class SegmentChord extends BaseSegmentChord {
  constructor(cCoord: Coord){
    super(cCoord)
    eventBus.on(EnumEventBus.segmentMode, (v: boolean) => this.handleSegmentVisible(v));
    new SegmentModeSwitcherCon();
  }
}